import React from "react";
import { FaSearch } from "react-icons/fa";
import "./filters.css";

const SearchBar = ({
  placeholder = "Search here",
  filterName = "search",
  inputRef,
  onSearch,
}) => {
  const handleSearchClick = () => {
    const value = inputRef?.current?.value?.trim() || "";
    onSearch?.(filterName, value);
  };

  const handleKeyDown = (event) => {
    if (event.key === "Enter") {
      handleSearchClick();
    }
  };

  return (
    <div className="searchbar-container-subcategory">
      <input
        className="searchbar-input-subcategory"
        type="text"
        placeholder={placeholder}
        ref={inputRef}
        onKeyDown={handleKeyDown}
      />
      <FaSearch
        className="search-icon-subcategory"
        onClick={handleSearchClick}
      />
    </div>
  );
};

export default SearchBar;
